import { render } from "./CreateGalleryComponent.vue?vue&type=template&id=04a1d8e0&ts=true"
import script from "./CreateGalleryComponent.vue?vue&type=script&lang=ts"
export * from "./CreateGalleryComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__